import React from 'react'

const SvgSocialShare = props => (
    <svg viewBox="0 0 56 56" {...props}>
        <path d="M28 0C12.5 0 0 12.5 0 28s12.5 28 28 28 28-12.5 28-28S43.5 0 28 0zm-6.5 27.9c0 .3 0 .6-.1.9l11 5.5c1-.9 2.4-1.5 3.9-1.5 3.2 0 5.7 2.5 5.7 5.6S39.4 44 36.3 44s-5.7-2.5-5.7-5.6v-.3l-11.4-5.7c-1 .7-2.1 1.1-3.4 1.1-3.2 0-5.7-2.5-5.7-5.6s2.6-5.6 5.7-5.6c1.4 0 2.7.5 3.7 1.3l11.1-5.5v-.5c0-3.1 2.6-5.6 5.7-5.6s5.7 2.5 5.7 5.6c0 3.1-2.6 5.6-5.7 5.6-1.4 0-2.7-.5-3.7-1.3l-11.1 5.5v.5z" />
    </svg>
)

export default SvgSocialShare



// WEBPACK FOOTER //
// ./src/ui/icons/SocialShare.js